import { Button, Form, Input } from "antd";
import { useCallback, useRef } from "react";
import styles from "./index.module.less";

export default function EditGroup({
  title,
  onOk,
  onCancel,
  okButtonProps,
  cancelButtonProps,
}) {
  const formRef = useRef(null);

  const onDone = useCallback(async () => {
    const values = formRef.current?.getFieldsValue(true) || null;
    onOk(values);
  }, [onOk]);

  return (
    <div className={styles.edit}>
      <div className={styles.wrapper}>
        <Form
          className={styles.form}
          layout="inline"
          ref={formRef}
          initialValues={{ title }}
          onFinish={onDone}
        >
          <Form.Item name="title">
            <Input
              autoFocus
              className={styles.input}
              maxLength={16}
              placeholder="分组名称，最大长度16个字符"
              onClick={(e) => e.stopPropagation()}
            />
          </Form.Item>
        </Form>
        <div className={styles.operation}>
          <Button
            className={styles.cancel}
            size="small"
            onClick={onCancel}
            {...okButtonProps}
          >
            取消
          </Button>
          <Button
            className={styles.ok}
            size="small"
            type="primary"
            onClick={onDone}
            {...cancelButtonProps}
          >
            确定
          </Button>
        </div>
      </div>
    </div>
  );
}
